module.exports = __webpack_public_path__ + "media/images/electrical-wrap-img-1-514cf2eecd8d28687ea6d8db4d18c91e.jpg";